/**
 * Keycloak browser client – only runs in the browser.
 * Do not import keycloak-js on the server (SSR).
 */
import type { KeycloakInstance } from "keycloak-js";
import { getKeycloakConfig, hasKeycloakConfig } from "./config";

let keycloakInstance: KeycloakInstance | null = null;

export function getKeycloak(): KeycloakInstance | null {
  if (typeof window === "undefined") return null;
  return keycloakInstance;
}

export async function ensureKeycloak(): Promise<KeycloakInstance | null> {
  if (typeof window === "undefined") return null;
  if (keycloakInstance) return keycloakInstance;
  if (!hasKeycloakConfig()) return null;

  const { url, realm, clientId } = getKeycloakConfig();
  const KeycloakConstructor: any = (await import("keycloak-js")).default;
  keycloakInstance = new KeycloakConstructor({ url, realm, clientId }) as KeycloakInstance;
  return keycloakInstance;
}

export function resetKeycloakClient(): void {
  keycloakInstance = null;
}

